export const SNOW_SEARCH_FIELD_FOCUSED = 'Snow Search Field Focused';
export const SNOW_SEARCH_FIELD_BLURRED = 'Snow Search Field Blurred';
export const SNOW_SEARCH_SUGGESTION_SELECTED = 'Snow Search Suggestion Selected';
export const SNOW_SEARCH_ITEM_SUGGESTION_SELECTED = 'Snow Search Item Suggestion Selected';
export const SNOW_SEARCH_DATE_SELECTED = 'Snow Search Date Selected';
export const SNOW_SEARCH_MODAL_TRIGGERED = 'Snow Search Modal Triggered';
